import { useCallback } from 'react'
import { useAlert, positions } from 'react-alert'

interface ToastParams {
  position?: string
  offset?: string
  timeout?: number
  [key: string]: any
}

interface UseToastAlertResult {
  toast: (text: string, params?: ToastParams) => void
}

export function useToastAlert(): UseToastAlertResult {
  const alert = useAlert()
  const toast = useCallback(
    (text: string, params?: ToastParams) => {
      alert.info(text, {
        position: positions.MIDDLE,
        offset: '300px',
        timeout: 2000,
        ...params,
      })
    },
    [alert]
  )

  return {
    toast: toast,
  }
}
